module.exports = __webpack_public_path__ + "static/media/coming-soon-bg.bc1fb2a6.jpg";